export var SpmPageLoadStatus;
(function (SpmPageLoadStatus) {
    SpmPageLoadStatus["EmptyState"] = "without data";
    SpmPageLoadStatus["Error"] = "with error";
    SpmPageLoadStatus["HasData"] = "with data";
})(SpmPageLoadStatus || (SpmPageLoadStatus = {}));
//# sourceMappingURL=page-load.enum.js.map